export default "__VITE_ASSET__CRV3IIN1__"